module.exports = __webpack_public_path__ + "static/media/GraphikRegular.e2a1876e.otf";